var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"actual-cate-manage"},[_c('CateTemplate',_vm._b({},'CateTemplate',_vm.templateConfig,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }